/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import {
  ButtonGroup,
  CircularProgress,
  IconButton,
  Paper,
  TableContainer,
  Tooltip,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { handleEditOpen, rowValue } from "../../../redux/Reducer/ModalSlice";
import TableFilter from "../../table-components/filter/TableFilter";
import TableComp from "../../table-components/table/TableComp";
import EditIcon from "@mui/icons-material/Edit";
import Pagination from "../../table-components/pagination/Pagination";
import AddModal from "../../modal/AddModal";
import EditModal from "../../modal/EditModal";
import AddStudy from "./AddStudy";
import EditStudy from "./EditStudy";
import {
  ActiveStatus,
  InactiveStatus,
  StatusContainer,
} from "../../Dashboard/Dashboard.style";

const StudySetup = () => {
  const dispatch = useDispatch();

  function handleEdit(rowData) {
    dispatch(handleEditOpen());
    dispatch(rowValue(rowData));
  }

  const {
    refetch,
    isLoading,
    data: studyInfo = [],
  } = useQuery({
    queryKey: ["studyInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/studyList`
      );
      const data = await res.json();
      return data;
    },
  });

  const columns = React.useMemo(
    () => [
      {
        Header: "Study Code",
        accessor: "study_code",
        Filter: false,
      },

      {
        Header: "Protocol Title",
        accessor: "protocol_title",
        Filter: false,
      },

      {
        Header: "Sponsor name",
        accessor: "sponsor_name",
        Filter: false,
      },

      {
        Header: "Active Status",
        accessor: "astatus_fg",
        Filter: false,
        Cell: (row) => (
          <div
            style={{
              marginLeft: "10Px",
              display: "flex",
              justifyContent: "start",
              alignItem: "center",
            }}
          >
            {row.row.original.astatus_fg === 1 ? (
              <StatusContainer>
                <ActiveStatus>Active</ActiveStatus>
              </StatusContainer>
            ) : (
              <StatusContainer>
                <InactiveStatus>Inactive</InactiveStatus>
              </StatusContainer>
            )}
          </div>
        ),
      },

      {
        Header: "Action",
        accessor: "col5",
        Cell: (row) => (
          <ButtonGroup
            style={{
              marginLeft: "10Px",
            }}
          >
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#2196F3" }}
              variant="none"
              onClick={() => handleEdit(row.row.original)}
            >
              <Tooltip title="Update">
                <EditIcon
                  // fontSize="small"
                  sx={{ fontSize: 18 }}
                />
              </Tooltip>
            </IconButton>
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );

  const add = useSelector((state) => state.Modal.add);
  const edit = useSelector((state) => state.Modal.edit);

  useEffect(() => {
    if (!add) {
      refetch();
    }
  }, [add]);

  useEffect(() => {
    if (!edit) {
      refetch();
    }
  }, [edit]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: studyInfo },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );
  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;

  return (
    <>
      <div>
        <TableFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          ButtonName="Add Study"
        />
      </div>

      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {isLoading && (
          <div
            style={
              {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "280px",
              }
              // display:"flex",
            }
          >
            <CircularProgress />
          </div>
        )}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>
      <AddModal ModalWidth="sm" ModalTitle="Add Study Information">
        <AddStudy />
      </AddModal>

      <EditModal ModalWidth="sm" ModalTitle="Edit Study Information">
        <EditStudy />
      </EditModal>
    </>
  );
};

export default StudySetup;
